import { uploaderRoutesNames } from '@app/client/uploader/uploader.routes.names';
import { DropboxUploaderGuard } from '@app/core/guards/dropbox-uploader.guard';
import { UploaderGuard } from '@app/core/guards/uploader.guard';
import { UploaderComponent } from './uploader.component';
import { Routes } from '@angular/router';

export const UPLOADER_ROUTES: Routes = [
  {
    path: uploaderRoutesNames.EMPTY_URL,
    component: UploaderComponent,
    children: [
      {
        path: uploaderRoutesNames.EMPTY_URL,
        canActivate: [UploaderGuard],
        loadChildren: () => import('@app/client/uploader/uploader-standard/uploader-standard.module').then(m => m.UploaderStandardModule),
      },
      {
        path: uploaderRoutesNames.DROPBOX,
        canActivate: [DropboxUploaderGuard],
        loadChildren: () => import('@app/client/uploader/uploader-dropbox/uploader-dropbox.module').then(m => m.UploaderDropboxModule),
      },
    ]
  },

];
